__turbopack_context__.v({
  "bottom": "Tooltip-module-scss-module__9sMNtG__bottom",
  "left": "Tooltip-module-scss-module__9sMNtG__left",
  "right": "Tooltip-module-scss-module__9sMNtG__right",
  "tooltip": "Tooltip-module-scss-module__9sMNtG__tooltip",
  "tooltip-title": "Tooltip-module-scss-module__9sMNtG__tooltip-title",
  "tooltip-wrapper": "Tooltip-module-scss-module__9sMNtG__tooltip-wrapper",
  "top": "Tooltip-module-scss-module__9sMNtG__top",
});
